
import { Component, Vue } from 'vue-property-decorator';
import LanguagePicker from '@/components/layout/LanguagePicker.vue';
@Component({
  components: { LanguagePicker },
})
export default class Navbar extends Vue {}
